import { render, staticRenderFns } from "./odds-tql-7.vue?vue&type=template&id=06f4631f&"
import script from "./odds-tql-7.vue?vue&type=script&lang=js&"
export * from "./odds-tql-7.vue?vue&type=script&lang=js&"
import style0 from "./odds-tql-7.vue?vue&type=style&index=0&id=06f4631f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports